import { SubmitErrorHandler, SubmitHandler } from "react-hook-form";

import { useUsersContext } from "../contexts/Users";
import { UserFormData } from "../types/users";

import { alertActions } from "../../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../../hooks/reduxHooks";
import { addUser, editUser } from "../../../../lib/api";

const useUserHandlers = () => {
    const { setFetchStatus, isAddingUser } = useUsersContext();
    const dispatch = useAppDispatch();

    const handleSubmit: SubmitHandler<UserFormData> = async data => {
        setFetchStatus("pending");
        try {
            isAddingUser ? await addUser(data) : await editUser(data);
            setFetchStatus("success");

            dispatch(
                alertActions.success({
                    title: `User added successfully`,
                    dismissible: true,
                }),
            );
        } catch (error: any) {
            setFetchStatus("failed");
            dispatch(
                alertActions.error({
                    title: `The server encountered a problem adding the new user.`,
                    text: error,
                    dismissible: true,
                }),
            );
        } finally {
            setFetchStatus(undefined);
        }
    };

    const handleError: SubmitErrorHandler<UserFormData> = data => {};

    return { handleSubmit, handleError };
};

export default useUserHandlers;
